// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"35fd5376","239":"ec0babc6","453":"86d8f9dc","667":"69446fbc"}[chunkId] + ".chunk.js";
};